import { useEffect, useId, useRef, useState } from 'react'

import LabelFloating from './label-floating'

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string
  initialValue?: string
  onUpdate?: (arg: string, ref?: HTMLSelectElement) => void
  fields: { key: string; label: string }[]
  tooltip?: string
}

export default function RadioFieldset(props: Props): JSX.Element {
  const { label, initialValue, onUpdate, fields, tooltip, ...inputProps } = props
  const ref = useRef<HTMLSelectElement>()
  const uid = useId()

  const [hasFocus, setFocus] = useState(false)
  const [input, setInput] = useState(initialValue)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const search = window.location.search
      const defVal = new URLSearchParams(search).get(inputProps.name) || (initialValue as string)
      if (defVal) setInput(defVal)
    }
    if (document.hasFocus() && ref.current === document.activeElement) setFocus(true)
  }, [])

  return (
    <LabelFloating
      label={label}
      uid={uid}
      hasFocus={hasFocus}
      hasInput
      required={inputProps.required}
      name={inputProps.name}
      tooltip={tooltip}
    >
      <div className="p-3">
        {fields.map((field) => (
          <label key={field.key} className="block dark:text-secondary-50">
            <input
              className="mr-1 "
              type="radio"
              name={inputProps.name}
              value={field.key}
              checked={input === field.key}
              onChange={(event) => {
                setInput(event.target.value)
                if (onUpdate) onUpdate(event.target.value)
              }}
            />
            {field.label}
          </label>
        ))}
      </div>
    </LabelFloating>
  )
}
